import React from 'react';
import { isEmpty, uniq, any } from 'underscore';
import { Stack, FontIcon, CommandButton } from '@fluentui/react';

import { Hotspot } from './hotspot';

declare let _TL_: any;

export interface IHotspot {
  glyph: string;
  title: string;
  desc: string;
  actionText: string;
  uri: string;
  placement: string;
}

interface IProps {
  i18n: any;
  enableHotSpotPlacement: boolean;
  onUpdateHotspots: (hotspots: IHotspot[]) => void;
  hotspots: IHotspot[];
  hideTitle: boolean;
  showHotspotCount: boolean;
}

interface IState {
  hotspots: IHotspot[];
  error: string;
}

const hotspotsUpperLimit = 3;

export class HotspotPanel extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      error: '',
      hotspots: props.hotspots || [],
    };
  }

  getData = () => this.state.hotspots.map(hotspot => ({
    Title: hotspot.title,
    Description: hotspot.desc,
    ActionText: hotspot.actionText,
    Uri: hotspot.uri,
    Glyph: hotspot.glyph,
    Placement: hotspot.placement,
  }));

  setError(error: string) {
    this.setState({
      error,
    });
  }

  handleChangeTextField = (index: number, field: string, value: string) => {
    const { hotspots } = this.state;

    hotspots[index][field] = value;

    this.setState({
      hotspots: [...hotspots],
    }, () => {
      this.props.onUpdateHotspots(this.state.hotspots);
    });
  };

  handleChangeGlyph = (index: number, value: string) => {
    const { hotspots } = this.state;

    hotspots[index].glyph = value;

    this.setState({
      hotspots: [...hotspots],
    }, () => {
      this.props.onUpdateHotspots(this.state.hotspots);
    });
  };

  handleChangePlacement = (index: number, value: string) => {
    const { hotspots } = this.state;

    hotspots[index].placement = value;

    this.setState({
      hotspots: [...hotspots],
    }, () => {
      this.props.onUpdateHotspots(this.state.hotspots);
    });
  };

  AddHotspot = () => {
    const { hotspots } = this.state;

    hotspots.push({
      glyph: 'ActionCenter',
      title: '',
      desc: '',
      actionText: '',
      uri: '',
      placement: '',
    });

    this.setState({
      hotspots: [...hotspots],
    }, () => {
      this.props.onUpdateHotspots(this.state.hotspots);
    });
  };

  handleRemoveHotspot = (index: number) => {
    const { hotspots } = this.state;

    hotspots.splice(index, 1);

    this.setState({
      hotspots: [...hotspots],
    }, () => {
      this.props.onUpdateHotspots(this.state.hotspots);
    });
  };

  validate = () => {
    const { i18n, enableHotSpotPlacement } = this.props;

    const missField = this.state.hotspots.map(i =>
      isEmpty(i.glyph) || isEmpty(i.title) || isEmpty(i.actionText) || isEmpty(i.uri) ||
      (enableHotSpotPlacement && isEmpty(i.placement)));

    if (any(missField)) {
      this.setError(i18n.getString(_TL_('HotSpot missing required field')));
      return false;
    }

    // check if any duplicate hotspot
    const hotspotStrings = this.state.hotspots.map(hotspot => hotspot.title + hotspot.actionText + hotspot.desc + hotspot.uri + hotspot.glyph);

    if (this.state.hotspots.length !== uniq(hotspotStrings).length) {
      this.setError(i18n.getString(_TL_('HotSpots duplication')));
      return false;
    }

    return true;
  };

  render() {
    const { i18n, showHotspotCount = false } = this.props;
    const {
      hotspots,
      error,
    } = this.state;

    const { hideTitle = false } = this.props;

    const disableAddhotspot = hotspots.length >= hotspotsUpperLimit;

    return (
      <div style={{ marginBottom: 5 }}>
        <h6>{!hideTitle && i18n.getString(_TL_('Hotspot'))}</h6>
        {hotspots.map((hotspot, index) => (
          <div
            className="hotspot"
            style={{
                border: '1px solid gray', borderRadius: 10, padding: 10, marginBottom: 5,
              }}
          >
            <Hotspot
              index={index}
              i18n={i18n}
              showHotspotCount={showHotspotCount}
              enableHotSpotPlacement={this.props.enableHotSpotPlacement}
              hotspot={hotspot}
              hotspots={hotspots}
              handleChangeTextField={this.handleChangeTextField}
              handleChangeGlyph={this.handleChangeGlyph}
              handleChangePlacement={this.handleChangePlacement}
            />
            <Stack horizontal horizontalAlign="space-between" >
              <span />
              <FontIcon
                className="delete-hotspot"
                style={{ cursor: 'pointer', marginTop: 5 }}
                onClick={this.handleRemoveHotspot.bind(this, index)}
                iconName="Delete"
                aria-label={i18n.getString(_TL_('Delete'))}
              />
            </Stack>
          </div>
          ))}
        <Stack horizontal horizontalAlign="space-between" >
          <div className="error" >{error}</div>
          <CommandButton
            styles={{ root: { marginLeft: 250 } }}
            iconProps={{ iconName: 'Add' }}
            className="add-hotspot"
            text={i18n.getString(_TL_('Add hotspot'))}
            onClick={this.AddHotspot}
            disabled={disableAddhotspot}
          />
        </Stack>
      </div>
    );
  }
}
